import React, { Component, PropTypes } from 'react';
import { TextInputField, SelectField, ResizableTextAreaField,
  RadioButtonField } from 'common/components/form_fields';

class PAPTextInputField extends Component {
  render() {
    const { extraHelp } = this.props;

    return (
      <div className="pap-text-input-field">
        <TextInputField {...this.props} />
        { extraHelp && <div className="extra-help">{ extraHelp }</div> }
      </div>
    );
  }
}

class PAPTextAreaField extends Component {
  render() {
    return (
      <div className="textarea-wrapper">
        <ResizableTextAreaField {...this.props} />
      </div>
    );
  }
}

class PAPSelectInputField extends Component {
  render() {
    return <SelectField allowEmpty={true} {...this.props}/>
  }
}

const PAPRadioInputField = (props) => {
  const { options } = props;

  return (
    <div className="radio-wrapper">
      { options.map((opt, i) => (
      <RadioButtonField {...props} key={i} value={opt.field} label={opt.label} />
      )) }
    </div>
  )
}

export { PAPTextInputField, PAPSelectInputField, PAPTextAreaField, PAPRadioInputField };
